import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_RelativeNavbar = _resolveComponent("RelativeNavbar")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_Hero),
    _createVNode(_component_Navbar),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { active: _ctx.scrollPosition > 100 }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "me" }, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("h2", null, "Mateusz Słotwiński")
        ], -1)),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.role')), 1)
      ]),
      _createVNode(_component_RelativeNavbar, { class: "only-active" })
    ], 2)
  ]))
}